<style>
    .v-select {
        border: 1px solid #d5d5d5;
    }

    .v-select.single.open .selected-tag {
        position: static;
    }

    .v-select.single .selected-tag {
        font-size: 18px;
        font-weight: 900;
        line-height: 1;
    }
    .v-select .selected-tag {
        margin: 0 2px 0;
        color: #000 !important;
    }

    .v-select .dropdown-menu li.active {
        pointer-events: all;
    }

    .v-select .dropdown-toggle .vs__actions .clear {
        display: none;
    }

    .v-select .dropdown-toggle {
        padding:10px 0;
        border-radius:0px;
    }

    .v-select .open-indicator {
        width:20px;
    }

    .v-select .dropdown-menu{
        min-width: initial;
        border: 2px solid #d5d5d5;
        border-top: 0;
        padding:0;
        border-radius: 0;
    }

    .v-select .dropdown-menu li {
        font-size: 15px;
        padding: 14px 0;
    }

    .v-select .dropdown-menu li.active a {
        font-weight: 900;
    }

    .v-select__steel {
        border: none;
    }
    .v-select__steel .dropdown-toggle {
        border: 2px solid #075096; /* TODO: nog overzien */
    }

    .v-select .vs__selected-options {
        align-items: center;
    }

.wmd-view-topscroll, .wmd-view {
    overflow-x: scroll;
    overflow-y: hidden;
    width: 300px;
    border: none 0px RED;
}

.wmd-view-topscroll { height: 20px; }
.wmd-view { height: 200px; }
.scroll-div1 {
    width: 1000px;
    overflow-x: scroll;
    overflow-y: hidden;
    height:20px;
}
.scroll-div2 {
    width: 1000px;
    height:20px;
}

.specify_tables h2 {
    position: sticky;
    top: 0px;
    background: #FFF;
    z-index: 2;
    padding-top: 5px;
    padding-bottom: 16px;
    margin-bottom: -2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #D9D9D9;
}
.specify_tables__scroll-arrows {
  display: flex;
  gap: 10px;
}
.specify_tables button {
    background-color: #FFF;
    display: inline-block;
    border: 0;
    outline: 0;
    color: #fff;
    width: 34px;
    height: 34px;
    cursor: pointer;
    box-shadow: inset 0 0 0 2px #BCBCBC;
}
.specify_tables button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
.specify_tables .arrow {
    position: relative;
    -webkit-touch-callout: none; /* prevent callout to copy image, etc when tap to hold */
    -webkit-user-select: none; /* prevent copy paste, to allow, change 'none' to 'text' */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
}
.specify_tables .arrow::before {
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center;
}
.specify_tables .arrow--left::before {
    content: '';
    background-image:url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%207%2010%22%3E%3Cpath%20fill%3D%22%23808080%22%20d%3D%22M1.5%209.4a.742.742%200%200%201-.54-.21.723.723%200%200%201%200-1.056L4.173%204.9.96%201.69a.723.723%200%200%201%200-1.056.723.723%200%200%201%201.055%200l3.75%203.75a.723.723%200%200%201%200%201.055l-3.75%203.75A.727.727%200%200%201%201.5%209.4Z%22%2F%3E%3C%2Fsvg%3E');
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    transform: rotate(180deg) scale(0.8);
}
.specify_tables .arrow--right::before {
    content: '';
    background-image:url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%207%2010%22%3E%3Cpath%20fill%3D%22%23808080%22%20d%3D%22M1.5%209.4a.742.742%200%200%201-.54-.21.723.723%200%200%201%200-1.056L4.173%204.9.96%201.69a.723.723%200%200%201%200-1.056.723.723%200%200%201%201.055%200l3.75%203.75a.723.723%200%200%201%200%201.055l-3.75%203.75A.727.727%200%200%201%201.5%209.4Z%22%2F%3E%3C%2Fsvg%3E');
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    transform: scale(0.8);
}

.lead p{
    color:#808080;
    text-transform:none;
}

.specify_tables__icon-legend {
  display: grid;
  grid-template-columns: 30px 1fr;
  align-items: center;
  padding:20px 6px 0 10px;
  font-weight: 500;
}

.specify_tables__icon-legend dt:first-of-type {
  color: #e95700;
}
.specify_tables__icon-legend dt:last-of-type{
  color: #3BA0DE;
}
.specify_tables__icon-legend dd {
  position: relative;
  top: 0.1ex;
}

</style>

<template>
    <div class="wpb_content specify">
        <div class="specify-content">
            <h2>WEBSHOP</h2>
            <p>Direct bestellen van voorbewerkte stalen.</p>
            <div class="lead">
                <p style="color:#808080; text-transform:none">
                    Via onze webshop kunt u eenvoudig prijzen inzien en direct bestellen.
                </p>

                <p v-html="category.content">
                </p>
            </div>
            <form action="" class="specify-form">
                <div class="specify-form-row clearfix">
                    <div class="form-label lg-select" style="width:100%;">
                        <strong>KIES EEN KWALITEIT</strong>
                        <v-select class="v-select v-select__steel" v-model="activeSteel" :options="steels" :searchable="false">

                        </v-select>
                    </div>

                    <div v-for="(options, key) in shapeOptions" class="specify-form__container">
                        <div class="specify-collapse">
                            <div class="specify-collapse__button" v-b-toggle="'collapse' + key">
                                <i class="specify-collapse__button-icon "></i>
                                <h5>
                                    {{options.name}}
                                </h5>
                            </div>
                            <b-collapse v-bind:id="'collapse' + key" :ref="'collapse'+key">

                                <div v-if="options.id == 4 || options.id == 5">
                                    <div>
                                        <dl class="specify_tables__icon-legend">
                                            <dt>
                                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                            </dt>
                                            <dd>
                                              Op aanvraag
                                            </dd>
                                            <dt>
                                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                            </dt>
                                            <dd>
                                              Op voorraad
                                            </dd>
                                        </dl>
                                    </div>
                                    <div class="specify_tables">
                                        <h2>
                                            <!--{{item.length}}mm-->

                                            <span class="specify_tables__scroll-arrows" oncontextmenu="return false">

                                                <button class="arrow arrow--left"
                                                        :disabled="true"
                                                        v-on:click.stop.prevent
                                                        @mousedown="scrollLeft"
                                                        @touchstart="scrollLeft"
                                                        @mouseleave="stopScrollLeft"
                                                        @mouseup="stopScrollLeft"
                                                        @touchend="stopScrollLeft"></button>
                                                <button class="arrow arrow--right"
                                                        :disabled="false"
                                                        v-on:click.stop.prevent
                                                        @mousedown="scrollRight"
                                                        @touchstart="scrollRight"
                                                        @mouseleave="stopScrollRight"
                                                        @mouseup="stopScrollRight"
                                                        @touchend="stopScrollRight"></button>
                                            </span>


                                        </h2>



                                        <!-- New table-->
                                        <div class="specify-table__container">

                                            <div class="specify-table specify-table__legend">
                                                <table>
                                                    <thead>
                                                    <tr>
                                                        <th>
                                                            <img src="/images/tabelDxVK.svg" loading="lazy" style="padding-left:8px;" alt="DxVK" />
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="widthItem in erodeerUniqueWidths(options.id)">
                                                        <th>{{ String(widthItem.width).replace('.', ',') }}x{{ String(widthItem.width).replace('.', ',') }}</th>
                                                    </tr>
                                                    <tr>
                                                        <th style="height:40px;"></th>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                            </div>

                                            <div class="specify-table specify-table__content" >
                                                <table>
                                                    <thead>
                                                    <tr>
                                                        <th v-for="thicknessItem in lengthOptions(options.id)"> {{ String(thicknessItem.length).replace('.', ',') }} </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="widthItem in erodeerUniqueWidths(options.id)">
                                                        <td v-for="thicknessItem in lengthOptions(options.id)" >
                                                            <div v-for="product in getPrice(widthItem.thickness, widthItem.width, thicknessItem.length, options.id)"
                                                                 @click="setProduct(product.id, $event)">
                                                                <span v-if="getStock(product.vrij_veld)" style="pointer-events:none;">
                                                                      <span v-if="customer" style="color:#3BA0DE;font-weight:600;">{{ Number(product.price) % 1 != 0 ? String(Number(product.price).toFixed(2)).replace('.', ',') : String(Number(product.price).toFixed(0)).replace('.', ',') }}</span>
                                                                      <span style="pointer-events:none;" v-else>
                                                                          <svg class="specify-table-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><path fill="#3BA0DE" d="M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"></path></svg>
                                                                          <svg class="specify-table-bull" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="#3BA0DE" cx="224" cy="256" r="100"/></svg>
                                                                      </span>
                                                                </span>
                                                                <span v-else style="pointer-events:none;">
                                                                      <span v-if="customer" style="font-weight:600;">{{ Number(product.price) % 1 != 0 ? String(Number(product.price).toFixed(2)).replace('.', ',') : String(Number(product.price).toFixed(0)).replace('.', ',') }}</span>
                                                                      <span style="pointer-events:none;" v-else>
                                                                          <svg class="specify-table-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><path fill="#3BA0DE" d="M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"></path></svg>
                                                                          <svg class="specify-table-bull" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                                                      </span>
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th class="bottom-header" v-for="thicknessItem in lengthOptions(options.id)"> {{ String(thicknessItem.length).replace('.', ',') }}</th>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>



                                    </div>
                                </div>

                                <div v-for="(item, key2) in lengthOptions(options.id)" v-else>

                                    <dl class="specify_tables__icon-legend">
                                        <dt>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                        </dt>
                                        <dd>
                                          Op aanvraag
                                        </dd>
                                        <dt>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                        </dt>
                                        <dd>
                                          Op voorraad
                                        </dd>
                                    </dl>
                                    <div class="specify_tables">
                                        <h2>
                                            {{item.length}}mm

                                            <span class="specify_tables__scroll-arrows" oncontextmenu="return false">

                                                <button class="arrow arrow--left"
                                                        :disabled="longLength(options.id, item.length).length <= 10"
                                                        v-on:click.stop.prevent
                                                        @mousedown="scrollLeft"
                                                        @touchstart="scrollLeft"
                                                        @mouseleave="stopScrollLeft"
                                                        @mouseup="stopScrollLeft"
                                                        @touchend="stopScrollLeft"></button>
                                                <button class="arrow arrow--right"
                                                        :disabled="longLength(options.id, item.length).length <= 10"
                                                        v-on:click.stop.prevent
                                                        @mousedown="scrollRight"
                                                        @touchstart="scrollRight"
                                                        @mouseleave="stopScrollRight"
                                                        @mouseup="stopScrollRight"
                                                        @touchend="stopScrollRight"></button>
                                            </span>


                                        </h2>



                                        <!-- New table-->
                                        <div class="specify-table__container">

                                            <div class="specify-table specify-table__legend">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <img src="/images/tabelBxD.svg" loading="lazy" alt="BxD" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="widthItem in widthItems(options.id, item.length)">
                                                            <th>{{ String(widthItem.width).replace('.', ',') }}</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="height:40px;"></th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="specify-table specify-table__content" >
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th v-for="thicknessItem in thicknessItems(options.id, item.length)"> {{ String(thicknessItem.thickness).replace('.', ',') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="widthItem in widthItems(options.id, item.length)">
                                                            <td v-for="thicknessItem in thicknessItems(options.id, item.length)" >
                                                                <div v-for="product in getPrice(thicknessItem.thickness, widthItem.width, item.length, options.id)"
                                                                    @click="setProduct(product.id, $event)">

                                                                     <span v-if="getStock(product.vrij_veld)" style="pointer-events:none;">
                                                                          <span v-if="customer" style="color:#3BA0DE;font-weight:600;">{{ Number(product.price) % 1 != 0 ? String(Number(product.price).toFixed(2)).replace('.', ',') : String(Number(product.price).toFixed(0)).replace('.', ',') }}</span>
                                                                          <span style="pointer-events:none;" v-else>
                                                                              <svg class="specify-table-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><path fill="#3BA0DE" d="M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"></path></svg>
                                                                              <svg class="specify-table-bull" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="#3BA0DE" cx="224" cy="256" r="100"/></svg>
                                                                          </span>
                                                                     </span>
                                                                     <span v-else style="pointer-events:none;">
                                                                          <span v-if="customer" style="font-weight:600;">{{ Number(product.price) % 1 != 0 ? String(Number(product.price).toFixed(2)).replace('.', ',') : String(Number(product.price).toFixed(0)).replace('.', ',') }}</span>
                                                                          <span style="pointer-events:none;" v-else>
                                                                              <svg class="specify-table-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><path fill="#3BA0DE" d="M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z"></path></svg>
                                                                              <svg class="specify-table-bull" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20"><circle fill="currentColor" cx="224" cy="256" r="100"/></svg>
                                                                          </span>
                                                                     </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th class="bottom-header" v-for="thicknessItem in thicknessItems(options.id, item.length)"> {{ String(thicknessItem.thickness).replace('.', ',') }}</th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>



                                    </div>
                                </div>




                            </b-collapse>
                        </div>
                    </div>

                </div>

            </form>
        </div>
        <aside class="right-sidebar right-sidebar--column">
            <!-- <div class="right-notice-banner">
                <h3>
                    Let op! Per 1 januari 2023 zijn wij helaas genoodzaakt om onze prijzen met 12% te verhogen.
                </h3>
                <p>
                    Deze verhoging wordt veroorzaakt door de stijgende kosten voor energie. De genoemde verhoging geldt op moment van levering, niet op moment van bestellen.
                </p>
            </div> -->

            <div class="right-bar-sticky-container">
                <div class="right-bar-inner">
                    <div class="right-bar-section heading-area">
                        <p class="code">
                            {{activeSteel.name}}
                        </p>
                        <p class="heading">{{activeSteel.type}}</p>
                    </div>
                    <div class="right-bar-section" v-if="product">
                        <h6>TOLERANTIE</h6>
                        <p v-if="shape.tolerantie_dikte"><span>Dikte</span><span>{{shape.tolerantie_dikte}}</span></p>
                        <p v-if="shape.tolerantie_breedte"><span>Breedte</span><span>{{shape.tolerantie_breedte}}</span></p>
                        <p v-if="shape.tolerantie_lengte"><span>Lengte</span><span>{{shape.tolerantie_lengte}}</span></p>
                    </div>
                    <div class="right-bar-section">
                        <h6>MAAT</h6>
                        <div v-if="shape.code == 'E' || shape.code == 'EH'">
                            <p><span>{{diameter ? "Diameter" : "Dikte"}}</span><span>{{length}} mm</span></p>
                            <p><span>Breedte</span><span>{{width}} mm</span></p>
                            <p><span>Lengte</span><span>{{thickness}} mm</span></p>
                        </div>
                        <div v-else>
                            <p v-if="length"><span>Lengte</span><span>{{length}} mm</span></p>
                            <p v-if="width && ! diameter"><span>Breedte</span><span>{{width}} mm</span></p>
                            <p v-if="thickness"><span>{{diameter ? "Diameter" : "Dikte"}}</span><span>{{thickness}} mm</span></p>
                        </div>
                    </div>
                    <div class="right-bar-section">
                        <h6>VORM & AANTAL</h6>
                        <p><span>Vorm</span><span>{{shape.name}}</span></p>
                        <p>
                            <span>Aantal</span>
                            <!--<span v-show="amount == 1">{{amount}} stuk</span>-->
                            <!--<span v-show="amount > 1">{{amount}} stuks</span>-->

                            <v-select class="v-select form-label md-select" v-model="amount" :options="amountOptions" :searchable="false"></v-select>
                        </p>

                        <p v-if="product && getStock(product.vrij_veld)">
                          <span>Op voorraad</span>
                          <span>Ja</span>
                        </p>

                        <p v-if="ESUSelected">Minimale bestelhoeveelheid van 120 euro per afmeting</p>
                    </div>
                    <div class="right-bar-section position-value">
                        <p v-if="product" class="right-bar-section__amount"><span>Aantal</span>
                            <span class="value" v-if="product" v-show="amount == 1">{{amount}} stuk</span>
                            <span class="value" v-if="product" v-show="amount > 1">{{amount}} stuks</span>
                        </p>
                        <p v-if="product && customer" class="right-bar-section__piece-price"><span>Stukprijs</span><span class="value" v-if="product">&euro;{{parseFloat(product.price * amount).toFixed(2)}}</span></p>

                        <p v-if="product && customer" class="right-bar-section__discount-price"><span>Korting <small class="small ex_btw">({{parseFloat(customer.discount_percentage).toFixed(0)}}%)</small></span><span class="value" v-if="product">&euro;{{((parseFloat(product.price * amount).toFixed(2) / 100) * parseFloat(customer.discount_percentage).toFixed(0)).toFixed(2)}}</span></p>
                        <p v-if="product && customer" class="right-bar-section__total-price"><span>Totaal <small class="small_ex_btw">(exclusief BTW)</small></span><span class="value" v-if="product">&euro;{{(parseFloat(product.price * amount).toFixed(2) - (parseFloat(product.price * amount).toFixed(2) / 100) * parseFloat(customer.discount_percentage).toFixed(0)).toFixed(2)}}</span></p>

                    </div>
                </div>
                <div>
                    <button v-if="customer" class="specify-btn" v-bind:disabled="! product || posting" @click="postItem(1)">IN WINKELMAND</button>
                </div>
                <button class="specify-btn-blue popup-btn" v-bind:disabled="! product || posting" @click="postItem(0)">OFFERTE</button>
            </div>
        </aside>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
    import vBToggle from 'bootstrap-vue/es/directives/toggle/toggle';

    Vue.component('b-collapse', bCollapse);
    Vue.directive('b-toggle', vBToggle);

    let SortedArray = require("collections/sorted-array");

    export default {
        props: {
            steels: {Array, required: true},
            steel: {Object, required: true},
            category: {Object, required: true},
            products: {Array, required: true},
            shapes: {Array, required: true},
            orderLine: {Object, required: false},
            customer: {Object, required: false},
            steelproducts: {Array, required: true},
            stockproducts: {Array, required: true}
        },
        components: {
            'v-select': vSelect
           },
        data: function() {
            return {
                shape: "",
                shapeOptions: [],
                activeSteel: this.steel,

                activeSteelProducts: this.steelproducts,

                amount: 1,
                amountOptions: [],

                length: "",
                width: "",
                thickness: "",

                product: null,
                diameter: false,
                posting: false,

                mouseDown: -1,
                timer: '',

                orderOrOffer: 0, // Order == true (1) ||||||| Offer == false (0);

                seen: true,

                guestOrderLines: [
                ]
            }
        },

        computed: {
            ESUSelected: function(){
                if(!this.activeSteel){
                    return false;
                }

                return this.activeSteel.label.includes('ESU')
            }
        },
        created: function() {
            for(let i = 1; i <= 99; i++) {
                this.amountOptions.push(i);
            }
        },
        filters: {
            // you can call this whatever you want to
            formatPrice (value) {
                return value.replace('.', ',');
            }
        },
        mounted: function() {
            let _this = this;
            Object.keys(this.shapes).forEach(function(key) {

                //Set the selected shape from the orderline when the user wants to edit the product from the cart

                _this.shapeOptions.push(_this.shapes[key]);
            }, _this);

            if(localStorage.getItem('guestShoppingcart')) {
                this.guestOrderLines = JSON.parse(localStorage.getItem('guestShoppingcart'));
            }

            // sessionStorage.setItem('guestShoppingcart', JSON.stringify([]));
            // localStorage.setItem('guestShoppingcart', JSON.stringify([]));

            //If there is no orderline set the first shape of the array as the active shape.
            (this.orderLine === undefined) ? this.shape = this.shapeOptions[0] : this.setSelectedValuesFromOrderLine();
        },
        methods: {

            setProduct: function(productId, event) {
                // if there are selected items, reset all, give markup to the newly selected item and apply a
                // flash animation on the right menu
                if (document.getElementsByClassName('selected').length > 0)
                    document.getElementsByClassName('selected')[0].className = "";

                // keyframes animation do not reset when a class is reset, which is stupid. This however, fixes that.
                document.getElementsByClassName('right-bar-inner')[0].className = "right-bar-inner";
                window.requestAnimationFrame(function(time) {
                    window.requestAnimationFrame(function(time) {
                        document.getElementsByClassName('right-bar-inner')[0].className = "right-bar-inner item-selected";
                    });
                });

                // Set selected to the chosen item
                event.target.className = 'selected';


                let items  = this.products.filter(function(value) {
                    return value.id === productId;
                }, productId);


                this.product = items[0];

                this.shape = this.shapeOptions.filter(function(value){
                    return value.id === items[0].shape_id;
                }, items)[0];

                this.length     = this.product.length;
                this.width      = this.product.width;
                this.thickness  = this.product.thickness;

                this.scrollDownToPrice(event);
            },
            postItem: function(orderOrOffer) {
                if(this.customer) {
                    this.postItemUser(orderOrOffer);
                } else {
                    this.posting = true;
                    let _this = this;

                    setTimeout(
                        function() {
                            _this.postItemGuest(orderOrOffer);
                            _this.saveGuestShoppingCart();
                            _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
                            _this.posting = false;
                        }, 1000);
                }
            },
            postItemUser: function(orderOrOffer) {
                this.orderOrOffer = orderOrOffer;

                this.posting = true;

                let url = '/order-line/store';

                if(this.orderLine !== undefined){
                    url = '/order-line/update/' + this.orderLine.id;
                }

                let _this = this;

                axios.post(url, {
                    product: this.product.id,
                    category: this.category.id,
                    amount: this.amount,
                    shape: this.shape.code,
                    orderOrOffer: this.orderOrOffer,
                    free: false,
                })
                .then(function (response) {
                    _this.wait(2000);
                    _this.posting = false;
                    _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
                    if(_this.orderLine === undefined){
                        window.incrementShoppingCart();
                    }
                }, _this)
                .catch(function (error) {
                    _this.wait(2000);
                    _this.posting = false;
                    _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                }, _this);

            },
            postItemGuest: function(orderOrOffer) {

                let _this = this;
                let elementFound = 0;

                let params = [
                    _this,
                    orderOrOffer
                ];

                if(this.guestOrderLines.length > 0) {
                    this.guestOrderLines.forEach(function(element) {
                        if(params[0].product.id === element.product_id &&
                            params[1] === element.order_offer) {
                            element.pieces += 1;
                            elementFound = 1;
                        }
                    }, params);
                }

                if( ! elementFound) {
                    let object = {
                        id: this.guestOrderLines.length +1,
                        product_id: this.product.id,
                        category: {
                            name: this.category.title
                        },
                        category_id: this.category.id,
                        order_offer: orderOrOffer,
                        article: this.product.article,
                        steel: {
                            name: this.activeSteel.name
                        },
                        steel_id: this.activeSteel.id,
                        steel_name: this.activeSteel.name,
                        steel_type: this.activeSteel.type,
                        pieces: this.amount,
                        price_per_piece: this.product.price,
                        shape: {
                            name: this.shape.name
                        },
                        shape_code: this.shape.code,
                        length: this.product.length,
                        width: this.product.width,
                        thickness: this.product.thickness,
                    };

                    window.incrementShoppingCart();

                    this.guestOrderLines.push(object);
                }
            },
            saveGuestShoppingCart: function() {
                localStorage.setItem('guestShoppingcart', JSON.stringify(this.guestOrderLines));
                $("#guestShoppingcart").val(localStorage.getItem('guestShoppingcart'));
            },
            wait: function(ms) {
                var start = new Date().getTime();
                var end = start;
                while(end < start + ms) {
                    end = new Date().getTime();
                }
            },
            changeShapes: function(){
                let _this = this;

                axios.post('/change-shape/' + this.activeSteel.slug)
                    .then(function (response) {
                        _this.shapeOptions  = Array.from(response.data.shapes);
                        _this.shape         = _this.shapeOptions[0];
                        _this.posting       = false;

                    }, _this)
                    .catch(function (error) {
                        _this.posting = false;
                        _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                    }, _this);

            },

            lengthOptions: function(shapeId) {
                let items = this.activeSteelProducts.filter(function(value, key) {
                    return value.shape_id === shapeId;
                }, shapeId);


                return _.orderBy(_.uniqBy(items, 'length'), 'length');
            },

            scrollDownToPrice: function(event) {
                if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) >= 992 ) {
                    return;
                }
                const body = document.documentElement || document.body;
                const priceRect = document.getElementsByClassName("right-sidebar")[0].getBoundingClientRect();

                //t = current time
                //b = start value
                //c = change in value
                //d = duration
                Math.easeInOutQuad = function (t, b, c, d) {
                    t /= d/2;
                    if (t < 1) return c/2*t*t + b;
                    t--;
                    return -c/2 * (t*(t-2) - 1) + b;
                };

                var start = body.scrollTop,
                    change = (priceRect.top + body.scrollTop) - body.scrollTop,
                    currentTime = 0,
                    increment = 20;

                var animateScroll = function(){
                    currentTime += increment;
                    var val = Math.easeInOutQuad(currentTime, start, change, 500);
                    body.scrollTop = val;
                    if(currentTime < 500) {
                        setTimeout(animateScroll, increment);
                    }
                };

                animateScroll();
            },

            scrollLeft: function (event) {
                let tableContainer = event.target.parentElement.parentElement.nextElementSibling;
                let tableContent = tableContainer.getElementsByClassName("specify-table__content")[0];

                let leftButton = event.target;
                let rightButton = event.target.nextElementSibling;

                const tableContentRect = tableContent.getBoundingClientRect();
                const tableRect = tableContent.firstChild.getBoundingClientRect();

                rightButton.disabled = "";

                let self = this;

                if (this.mouseDown==-1) {
                    this.timer = setInterval(function(){
                        self.scrollLeftWhileMouseDown(tableContent);
                    }, 50);
                }

                if (tableContent.scrollLeft === 0) {
                    clearInterval(this.timer);
                    this.mouseDown = -1;
                    leftButton.disabled = "disabled";
                }
            },

            scrollLeftWhileMouseDown: function(tableContent) {
                setInterval((tableContent.scrollLeft -= 100), 100);
            },

            stopScrollLeft: function (event) {
                let tableContainer = event.target.parentElement.parentElement.nextElementSibling;
                let tableContent = tableContainer.getElementsByClassName("specify-table__content")[0];

                let leftButton = event.target;

                clearInterval(this.timer);
                this.mouseDown = -1;

                if (tableContent.scrollLeft === 0) {
                    leftButton.disabled = "disabled";
                }
            },

            scrollRight: function (event) {
                let tableContainer = event.target.parentElement.parentElement.nextElementSibling;
                let tableContent = tableContainer.getElementsByClassName("specify-table__content")[0];

                let leftButton = event.target.previousElementSibling;
                let rightButton = event.target;

                leftButton.disabled = "";

                const tableContentRect = tableContent.getBoundingClientRect();
                const tableRect = tableContent.firstChild.getBoundingClientRect();

                let self = this;

                if (this.mouseDown==-1) {
                    this.timer = setInterval(function(){
                        self.scrollRightWhileMouseDown(tableContent);
                    }, 50);
                }

                if (tableContent.scrollLeft + Math.ceil(tableContentRect.width) >= tableRect.width) {
                    clearInterval(this.timer);
                    this.mouseDown = -1;
                    rightButton.disabled = "disabled";
                }
            },

            scrollRightWhileMouseDown: function(tableContent) {
                setInterval((tableContent.scrollLeft += 100), 100);
            },

            stopScrollRight: function (event) {
                let tableContainer = event.target.parentElement.parentElement.nextElementSibling;
                let tableContent = tableContainer.getElementsByClassName("specify-table__content")[0];

                let rightButton = event.target;

                const tableContentRect = tableContent.getBoundingClientRect();
                const tableRect = tableContent.firstChild.getBoundingClientRect();

                clearInterval(this.timer);
                this.mouseDown = -1;

                if (tableContent.scrollLeft + Math.ceil(tableContentRect.width) >= tableRect.width) {
                    rightButton.disabled = "disabled";
                }
            },

            widthItems: function (shapeId, length) {
                let params = [shapeId, length];
                let items = this.activeSteelProducts.filter(function(value, key) {
                     return value.shape_id === params[0] && Number(value.length) === params[1];
                }, params);
                return _.orderBy(_.uniqBy(items, 'width'), 'width');

            },
            thicknessItems: function (shapeId, length) {

                let params = [shapeId, length];

                let items = this.activeSteelProducts.filter(function(value, key) {
                    return value.shape_id === params[0] && Number(value.length) === params[1];
                }, params);
                return _.orderBy(_.uniqBy(items, 'thickness'), 'thickness');
            },
            erodeerUniqueWidths: function(shapeId) {
                let items = this.activeSteelProducts.filter(function(value, key) {
                    return value.shape_id === shapeId;
                }, shapeId);

                return _.orderBy(_.uniqBy(items, 'width'), 'width');
            },
            getPrice(thickness, width, length, shapeId) {

                let sizes = [thickness, width, length, shapeId, this.activeSteel.id];

                let item = this.activeSteelProducts.filter(function(value, key){
                     return Number(value.thickness) === sizes[0]
                            && Number(value.width) === sizes[1]
                            && Number(value.length) === sizes[2]
                            && value.shape_id === sizes[3]
                            && value.steel_id === sizes[4];
                }, sizes);

                return item[0] ? item : "";
            },
            getStock(articleNumber){
                let item = this.stockproducts.filter(function(product, key){
                     return product.article_number === articleNumber;
                }, articleNumber);

                return item[0] ? item[0].stock > 0 : 0;
            },
            longLength: function(shapeId, length) {
                let params = [shapeId, length];

                let items = this.activeSteelProducts.filter(function(value, key) {
                    return value.shape_id === params[0] && Number(value.length) === params[1];
                }, params);

                return _.orderBy(_.uniqBy(items, 'thickness'), 'thickness');
            }
        },
        watch: {
            activeSteel: {
                handler: function(val) {
                    this.activeSteelProducts = this.activeSteel.products;
                    this.product = null;
                    this.length     = null;
                    this.width      = null;
                    this.thickness  = null;
                    this.changeShapes();
                }
            },
            shape: {
                handler: function(val) {
                    this.amount = 1;
                    if(this.shape.code == "R") {
                        this.diameter = true;
                    } else {
                        this.diameter = false;
                    }
                }
            },
            orderLine: {
                handler: function(val) {
                    this.setSelectedValuesFromOrderLine();
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/specificeren-v2.vue